import React from "react";
import Header from "../components/header/Header";
import Slider from "../components/slider/Slider";
import About from "../components/about/About";
import Team from "../components/team/Team";
import WhyUs from "../components/whyus/WhyUs";
import CallToAction from "../components/calltoactions/CallToAction";
import Footer from "../components/footer/Footer";
import Services from "../components/services/Services";
import SEO from "../components/SEO";

const Home = () => {
  return (
    <div className="home-three">
      <SEO
        title="וידבסקי ושות׳ — משרד עורכי דין בבאר שבע | ייעוץ וייצוג משפטי"
        description="משרד עו״ד וידבסקי ושות׳ — משרד עורכי דין בבאר שבע. ייצוג, ליווי וייעוץ משפטי בליטיגציה, נדל״ן, תעבורה, נזיקין, דיני משפחה, משפט מסחרי, חדלות פירעון והוצאה לפועל. צרו קשר לייעוץ ראשוני."
        path="/"
        includeOrganization
        breadcrumbs={[{ name: "דף הבית", url: "/" }]}
      />
      <Header />
      <Slider />
      <About />
      <Services />
      <Team />
      <WhyUs />
      <CallToAction />
      <Footer />
    </div>
  );
};

export default Home;
